/* eslint-disable no-console */
import useUserStore from '../store/userStore/userStore';

import {yearSelect} from './FormUtils/yearSelect';

export const convertPxToRem = (
  value: number,
  isImportant: boolean = false
): string => {
  return `${value / 16}rem ${isImportant ? '!important' : ''}`;
};

export const splitSentenceIntoTwo: (text: string) => string[] = (text) => {
  const length = text?.length ?? 2;
  let middleIndex = Math.floor(length / 2);

  const before = text.lastIndexOf(' ', middleIndex);
  const after = text.indexOf(' ', middleIndex + 1);

  if (before === -1 && after === -1) {
    return [text, ''];
  }

  if (
    before === -1 ||
    (after !== -1 && after - middleIndex < middleIndex - before)
  ) {
    middleIndex = after;
  } else {
    middleIndex = before;
  }

  // Split the string at the chosen space index
  const firstPart = text.substring(0, middleIndex);
  const secondPart = text.substring(middleIndex + 1);

  return [firstPart, secondPart];
};
export enum UserRole {
  Checker_Role = 'access:Checker',
  Maker_Role = 'access:Maker',
  Both_role = 'access:Both',
  View_Only = 'access:View Only',
  Company_Admin = 'Company Admin',
  Company_user = 'Company User',
  Facility_Admin = 'Facility Admin',
  Facility_User = 'Facility User'
}

export const getStatusColor = (
  value: string
): {color: string; text: string} => {
  let color: string;
  let text: string;

  switch (value) {
    case 'rejected':
      color = '#F4B9BC';
      text = 'Rejected';
      break;
    case 'accepted':
      color = '#91C577';
      text = 'Accepted';
      break;
    case 'in_review':
      color = '#8ba7b8';
      text = 'In-Review';
      break;
    default:
      color = '#8ba7b8';
      text = value || 'Unknown';
      break;
  }

  return {color, text};
};

export const hasUserRole = (role: UserRole): boolean => {
  const {userRoles} = useUserStore.getState();

  return userRoles?.includes(role);
};

export const hasViewRole = (role: UserRole): boolean => {
  const {userRoles} = useUserStore.getState();

  return userRoles?.includes(role);
};

export const getScopesByFacility = (
  getEmissionFactors: any,
  country: number
): any => {
  const scope1EFDB: any = [];
  const scope2EFDB: any = [];
  const scope3EFDB: any = [];
  const defaultEFDB: any = [];

  getEmissionFactors.forEach((item: any) => {
    if (
      item.scope.includes(1) &&
      item.defaultCountryScope.some((item: any) => {
        return item.scope === 1 && item.country === country;
      })
    ) {
      scope1EFDB.push(item);
    } else if (
      item.scope.includes(2) &&
      item.defaultCountryScope.some((item: any) => {
        return item.scope === 2 && item.country === country;
      })
    ) {
      scope2EFDB.push(item);
    } else if (
      item.scope.includes(3) &&
      item.defaultCountryScope.some((item: any) => {
        return item.scope === 3 && item.country === country;
      })
    ) {
      scope3EFDB.push(item);
    }

    if (item?.allDefault?.length > 0) {
      defaultEFDB.push(item);
    }
  });

  return {
    scope1:
      scope1EFDB.length > 0
        ? scope1EFDB?.[0].value
        : defaultEFDB.find((item: any) => {
            return item.allDefault.includes(1);
          })?.value,
    scope2:
      scope2EFDB.length > 0
        ? scope2EFDB?.[0].value
        : defaultEFDB.find((item: any) => {
            return item.allDefault.includes(2);
          })?.value,
    scope3:
      scope3EFDB.length > 0
        ? scope3EFDB?.[0].value
        : defaultEFDB.find((item: any) => {
            return item.allDefault.includes(3);
          })?.value
  };
};

export const checkCurrentYearOrBelow = (year: string | null): string => {
  const allAllowedYears = yearSelect();
  const currentYear = allAllowedYears?.[0]?.value;
  if (!year) {
    return currentYear;
  } else {
    const isInAllowedYears = allAllowedYears.some(
      (item) => item.value === year
    );

    return isInAllowedYears ? year : currentYear;
  }
};
